module.exports = __webpack_public_path__ + "static/images/gift-bg-all.1556eb4.png";